export default "__VITE_ASSET__BhqklcWH__"